module.exports = __webpack_public_path__ + "img/system_catch01.aaf97253.jpg";